import Vue from 'vue';
import VueRouter from 'vue-router';
import { Component } from 'vue-property-decorator';
import middleware_pipeline from '@/middleware';
// import auth from '@/middleware/pipes/auth';
import auth_keycloak from '@/middleware/pipes/auth-keycloak';
import access_roles from '@/middleware/pipes/access-roles';
import routes from './routes';

Component.registerHooks([
  'beforeRouteEnter', 'beforeRouteUpdate', 'beforeRouteLeave',
]);

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    window.scrollTo(0, 0);
  },
});

// auth,
router.beforeEach((to, from, next) => {
  const default_middlewares = [
    auth_keycloak, access_roles,
  ];

  const middleware = to?.meta?.middleware?.length ? to.meta.middleware : default_middlewares;

  window.document.title = to?.meta && to?.meta.title ? to?.meta.title : 'АТОЛ – Личный кабинет пользователя';

  const context = {
    to,
    from,
    next,
    next_middleware: next,
  };

  return middleware[0]({
    ...context,
    next_middleware: middleware_pipeline(context, middleware, 1),
  });
});

router.afterEach((to, from) => {
  if (typeof window.ym !== 'function') return;

  window.ym(106604585, 'hit', to.fullPath, {
    title: document.title,
    referer: from.fullPath || null,
    notBounce: true,
    params: {
      route_name: to.name || null,
      has_query: Boolean(Object.keys(to.query).length),
    },
  });
});

export default router;
